<template>
    <div class="card border-light borda-redonda sombra">
        <div class="card-body">
            <h6 class="card-title text-center">
                O prestador chegou ao local?
            </h6>
            <div class="card-text">
                <div class="col-12 mb-3 lh-18">
                    <small>
                        Confirme a chegada do prestador.
                    </small>
                </div>
                <div class="col-12 p-0 text-center">
                    <button type="button"
                        class="btn btn-success"
                        @click="marcarChegada()"
                        :disabled="loading"
                    >
                        {{ loading ? `Aguarde ...` : `Confirmar` }}
                        <i class="fa fa-check" aria-hidden="true"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
    data() {
        return {
            loading: false,
        }
    },
    props: {
        idServicoAtendimento: String,
        servico: {
            type: Object,
            default: function () {
                return {};
            },
        }
    },
    computed: {
        ...mapState('Atendimento', {
            temServicos: 'temServicos',
        }),
    },
    methods: {
        ...mapActions("Atendimento", ["enviarMarcacaoChegada"]),
        marcarChegada() {
            const h = this.$createElement;
            let mensagem = '';
            mensagem = h('div', [
                    h('i', { class: "fa fa-exclamation-triangle text-warning" }),
                    ' Tem certeza que deseja informar à assistência que prestador chegou ao seu local para realizar o atendimento?',
                ]
            );

            this.$bvModal.msgBoxConfirm(
                mensagem,
                {
                    okTitle: "Sim",
                    cancelTitle: "Não",
                    cancelVariant: "default",
                    centered: true,
                }
            ).then((value) => {
                this.loading = value;
                if (value === true) {
                    const dataHoraChegada = this.$moment().format("DD/MM/YYYY HH:mm:ss");
                    this.enviarMarcacaoChegada({
                        idServicoAtendimento: this.idServicoAtendimento, dataHoraChegada
                    }).then((data) => {
                        this.$bvModal.msgBoxOk(data.message, { centered: true });
                        this.loading = false;
                    }).catch((data) => {
                        this.$bvModal.msgBoxOk(data.message, { centered: true });
                        this.loading = false;
                    });
                }
            }).catch(() => {
                this.loading = false;
            });
        },
        
    }
}
</script>
